import { MinimumRestAndMealBreaks } from './types';

const restBreakLength = 10;
const mealBreakLength = 30;

/**
 * Calculate minimum rest and meal breaks for employees
 * {@link https://www.employment.govt.nz/assets/Uploads/tools-and-resources/documents/abf4cdb0e9/rest-meal-break-table.pdf}
 * @param {number} workPeriodMinutes Length of employee’s work period
 * @returns {object}
 */
const calculateMinimumRestAndMealBreaks = (
    workPeriodMinutes: number
): MinimumRestAndMealBreaks => {
    let numberOfRestBreaks = 0;
    let numberOfMealBreaks = 0;
    const workPeriodHours = workPeriodMinutes / 60;

    // 2.00 - 4.00 hours
    if (workPeriodHours >= 2 && workPeriodHours <= 4) {
        numberOfRestBreaks = 1;
    }
    // 4.01 - 6.00 hours
    if (workPeriodHours > 4 && workPeriodHours <= 6) {
        numberOfRestBreaks = 1;
        numberOfMealBreaks = 1;
    }
    // 6.01 - 10.00 hours
    if (workPeriodHours > 6 && workPeriodHours <= 10) {
        numberOfRestBreaks = 2;
        numberOfMealBreaks = 1;
    }
    // 10.01 – 12 hours
    if (workPeriodHours > 10 && workPeriodHours <= 12) {
        numberOfRestBreaks = 3;
        numberOfMealBreaks = 1;
    }
    // 12.01 to 14 hours
    if (workPeriodHours > 12 && workPeriodHours <= 14) {
        numberOfRestBreaks = 3;
        numberOfMealBreaks = 2;
    }
    // 14.01 to 16 hours
    if (workPeriodHours > 14) {
        numberOfRestBreaks = 4;
        numberOfMealBreaks = 2;
    }
    return {
        numberOfRestBreaks,
        totalRestBreaksMinutes: numberOfRestBreaks * restBreakLength,
        numberOfMealBreaks,
        totalMealBreaksMinutes: numberOfMealBreaks * mealBreakLength
    };
};

export default calculateMinimumRestAndMealBreaks;
